<template>
  <div>
    <h3>{{ card.name }}</h3>
    <div v-if="card.metrics" class="badges">
      <span v-if="card.metrics.is_domestic">国产</span>
      <span>{{ card.metrics.memory_gb != null ? card.metrics.memory_gb + 'GB' : '—' }}</span>
      <span>{{ card.metrics.fp16_tflops != null ? 'FP16 ' + card.metrics.fp16_tflops + 'T' : '—' }}</span>
      <span v-if="card.metrics.fp8_tflops != null">FP8 {{ card.metrics.fp8_tflops }}T</span>
      <span>{{ card.metrics.tdp_w != null ? card.metrics.tdp_w + 'W' : '—' }}</span>
      <span v-if="card.budget_note" class="note">{{ card.budget_note }}</span>
    </div>
    <ul v-if="priced.length" class="prices">
      <li v-for="(row, index) in priced" :key="index">
        {{ row.variant_name }}
        <template v-if="row.msrp"> · 官方 {{ row.msrp }} {{ row.currency }}</template>
        <template v-if="row.market_price"> · 市场 {{ row.market_price }} {{ row.currency }}</template>
        <template v-if="row.secondhand_price"> · 二手 {{ row.secondhand_price }} {{ row.currency }}</template>
        <span v-if="row.price_month"> · {{ row.price_month }}</span>
      </li>
    </ul>
    <p v-else class="none">卡库里暂无这条价格。</p>
  </div>
</template>

<script>
export default {
  name: 'CardPick',
  props: {
    card: { type: Object, required: true }
  },
  computed: {
    priced() {
      return (this.card.prices || []).filter((row) => row.msrp || row.market_price || row.secondhand_price)
    }
  }
}
</script>

<style scoped>
h3 { margin: 0 0 8px; font-size: 18px; }
.badges { display: flex; flex-wrap: wrap; gap: 6px; }
.badges span, .prices li {
  background: #f2f3f5;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  color: #4e5969;
}
.prices { list-style: none; margin: 10px 0 0; padding: 0; display: grid; gap: 6px; }
.prices li { border-radius: 12px; padding: 8px 10px; }
.none { margin: 8px 0 0; color: #86909c; font-size: 12px; }
.badges span.note { background: #fff7e8; color: #d25f00; border-radius: 12px; }
</style>
